import clsx from "clsx";
import { Text } from "preact-i18n";

import { Popover } from "@mui/material";

import { SyncLock, Lock } from "@mui/icons-material";

import GreenDot from "../GreenDot/GreenDot";

import style from "./style.module.css";

const ConnectionPopover = ({ anchorElement, onClose }) => {
  const open = Boolean(anchorElement);
  const id = open ? "simple-popover" : undefined;

  return (
    <Popover
      id={id}
      open={open}
      anchorEl={anchorElement}
      onClose={onClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "center",
      }}
    >
      <div
        class={clsx(style.grid, "p-4 grid gap-y-2 gap-x-2.5")}
        onMouseLeave={onClose}
      >
        <div className="flex h-full w-full items-center justify-center">
          <GreenDot />
        </div>
        <Text id="ConnectionPopover.connected" />
        <SyncLock />
        <Text id="ConnectionPopover.transport" />
        <Lock />
        <Text id="ConnectionPopover.rest" />
      </div>
    </Popover>
  );
};

export default ConnectionPopover;
